async function getRequest(url) {
  const response = await fetch(url);
  const data = await response.json();
  return data;
}

async function postRequest(url, body, warningMsg) {
  const payload = {
    ...body,
    id: ShopifyAnalytics.meta.selectedVariantId,
    quantity: 1,
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      if (warningMsg) warningMsg.style.display = "block";
      throw new Error(`POST failed: ${response.status}`);
    }
    window.location.href = "/cart";
  } catch (error) {
    console.error(error);
  }
}

document.addEventListener("submit", function (event) {
  const form = event.target.closest(".code_password");
  if (!form) return;
  event.preventDefault();
  const passwordInput = form.querySelector('input[name="password"]');
  const warningMsg = form.querySelector(".password-warning");
  const successMsg = form.querySelectorAll("p")[1];

  const password = passwordInput.value.trim().toLowerCase();
  const correct = (window.correctPassword || "").trim().toLowerCase();

  if (password && correct && password == correct) {
    warningMsg.style.display = "none";
    successMsg.style.display = "block";
    postRequest("/cart/add.js", {}, warningMsg);
  } else {
    successMsg.style.display = "none";
    warningMsg.style.display = "block";
  }
});

function setButtonState(button, state) {
  const states = {
    loading: {
      disabled: true,
      opacity: "0.5",
      cursor: "not-allowed",
      text: "Signing up...",
    },
    default: {
      disabled: false,
      opacity: "1",
      cursor: "pointer",
      text: "Sign up",
    },
  };
  const config = states[state];
  button.disabled = config.disabled;
  button.style.opacity = config.opacity;
  button.style.cursor = config.cursor;
  button.textContent = config.text;
}

function formFieldValue(form, name) {
  const field = form.querySelector(`[name="${name}"]`);
  if (!field) return "";
  if (field.type === "radio" || field.type === "checkbox") {
    const checked = form.querySelector(`[name="${name}"]:checked`);
    return checked ? checked.value.trim() : "";
  }
  return (field.value || "").trim();
}

function validateWaitlistForm(form) {
  if (typeof validateForm === "function") {
    return validateForm();
  }

  const height = formFieldValue(form, "height");
  const size = formFieldValue(form, "size");

  if (!height || !size) {
    document.querySelector(".checkbox-error")?.style.setProperty("display", "flex");
    return false;
  }

  return true;
}

function handleSuccessUI() {
  const activeStep = document.querySelector(
    ".waitlist-step-form .waitlist-step.is-active"
  );
  const finalStep = document.querySelector(
    ".waitlist-step-form .waitlist-step.final-step"
  );

  activeStep?.classList.remove("is-active");
  finalStep?.classList.add("is-active");

  document.querySelector(".step2")?.style.setProperty("display", "none");
  document.querySelector(".waitlist-step-form1")?.classList.remove("join-now-step");
  document.querySelector(".waitlist-step-form1")?.classList.add("you're-in-step");
  document.querySelector(".pass-inbox")?.style.setProperty("display", "flex");

  $(".join-the-waitlist").hide();
  $(".you-in").show();

  document.querySelector(".waitlist-step-form")?.classList.add("submit-dn");
  document.querySelector(".waitlist-step")?.classList.remove("is-active");
  document.querySelector(".final-step")?.classList.add("is-active");
}

document.addEventListener("submit", async function (e) {
  if (!e.target.matches("#waitlistForm")) return;
  e.preventDefault();

  const form = e.target;
  const submitButton = form.querySelector('button[type="submit"]');

  document.querySelector(".checkbox-error")?.style.setProperty("display", "none");

  if (!validateWaitlistForm(form)) return;

  const formData = new FormData(form);
  formData.append("products[]", "6702b0ffd17ab40c2fa8e719");

  try {
    setButtonState(submitButton, "loading");

    const http = await fetch(
      "https://alina-diaz-lead-api.sophia-b1e.workers.dev",
      {
        method: "POST",
        body: formData,
        headers: { Accept: "application/json" },
      }
    );

    const result = await http.json();
    console.log(result);

    if (result.status === "failed") {
      document.querySelectorAll(".status-f").forEach((el) => {
        el.style.display = "flex";
      });
      return;
    }

    if (!http.ok || result.success !== true) {
      document.querySelector(".checkbox-error")?.style.setProperty("display", "flex");
      return;
    }

    handleSuccessUI();
  } catch (error) {
    console.error("Form submission error:", error);
    document.querySelector(".checkbox-error")?.style.setProperty("display", "flex");
  } finally {
    setButtonState(submitButton, "default");
  }
});

$(document).ready(function () {
  $(".sign_up1").on("click", function (e) {
    $(".exclusive-access").css("display", "none");
    $(".join-the-waitlist").css("display", "flex");
    e.preventDefault();
    $(".waitlist-right.password-hero__inner").css("display", "none");
    document.querySelector(".waitlist-step-form1").classList.remove("exclusive-access-step");
    document.querySelector(".waitlist-step-form1").classList.add("join-now-step");
    $(".step2").css("display", "flex");
  });
});

document.addEventListener("click", function (e) {
  const formWrapper = document.querySelector(".waitlist-step-form1");
  const modalBox = document.querySelector(".waitlist-inner");
  const waitlistrigt = document.querySelector(".waitlist-right");
  if (!formWrapper || !modalBox || !waitlistrigt) return;
  const clickedInsideModal = modalBox.contains(e.target);
  if (!clickedInsideModal) {
    formWrapper.style.display = "none";
    document.querySelectorAll(".status-f").forEach((el) => {
      el.style.display = "none";
    });
  }
});

document.addEventListener("click", function (e) {
  if (e.target.closest(".waitlist-done")) {
    location.reload();
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const crossicon = document.querySelector(".cross-icon");
  const formSection = document.querySelector(".waitlist-step-form");
  if (!crossicon || !formSection) return;
  crossicon.addEventListener("click", () => {
    formSection.style.display = "none";
  });
});